
<template>
  <div class="affairs-container"  v-scroll-animate="'fly-in-right5gy'" v-if="cengji==1">
    <div class="article-grid">
      <!-- <div 
        v-for="(article, index) in articles" 
        :key="index"
        class="article-card"
        @click="$router.push(`/article/${article.id}`)"
      > -->
      
      <div class="divAll"  v-for="(item, index) in articles" :key="item.id" :class="{ 'activedivAll': isHover && (nowIndex == index) }" @mouseover="isHover = true;nowIndex=index"  @mouseleave="isHover = false;nowIndex=null">
         
          <div class="divR"  @click="goDetailFn(index)" >
            <h1 >{{ item.title }}</h1>
            <p v-blank-link  v-html="item.content" class="details" ></p>
                    
          </div>

          <div class="divL"  @click="goDetailFn(index)" > 
            
            <a class="blockA"  >
                        <span>{{ item.createDate.substr(0,10).split('-')[1] }}.{{ item.createDate.substr(0,10).split('-')[2] }}</span>
                        <span>{{ item.createDate.substr(0,10).split('-')[0] }}</span>
                      </a>
          </div>
        </div>
    </div>
    <div class="change_page" >
      <el-button 
      class="pagination-btn first-last"
      :disabled="currentPage === 1"
      @click="$emit('page-change', 1)"
    >
      首页
    </el-button >
    <el-pagination
    layout="prev, pager, next"
    :total="totalNum"
    :page-size="pageSize"
    :current-page="currentPage"
    background
    @current-change="handleCurrentChange"
  />
  
    <el-button  
     class="pagination-btn first-last"
      :disabled="currentPage === totalPages"
      @click="$emit('page-change', totalPages)"
    >
      末页
    </el-button >
  </div>

 
  </div>

  <div v-else-if="cengji==2" >
    <ArticleDetail :nowObj="nowObj" :articles="articles" :indexNum="indexNum"  />
  </div>

  
  
</template>

<script>
import ArticleDetail from '@/components/infogw/ArticleDetail.vue'

export default {
  props: {
    articles: Array,
    currentPage: Number,
    totalPages: Number,
    totalNum: Number,
    pageSize: Number
  },
  data() {
    return {
      cengji:1,
      nowObj:{},
      indexNum:null,
      isHover:false,
      nowIndex:null,

    }
  },
  components: {
    ArticleDetail
  },
  computed: {
    totalPage() {
    return Math.ceil(totalNum / pageSize); // 确保使用组件内pageSize
  },
    pageRange() {
      return Array.from({length: this.totalPages}, (_, i) => i + 1)
    }
  },
  watch: {
    cengji(val) {
        if(val == 1){
          this.changeCengji0()
        }
    },
  },
  methods: {
    changeCengji0(){
     
      
      this.$emit('changeCengji0')
    },
    changeCengji(){
      
      this.$emit('changeCengji')
    },
    goDetailFn(indexNum){
      
      // this.cengji=2
      // this.indexNum=indexNum
      this.nowObj=this.articles[indexNum]
      debugger
      // this.changeCengji()
                window.open('/newsDetailHome?artId='+this.nowObj.id+'&zl=infoOpen', '_blank');

    },
    handleCurrentChange(val){
      this.$emit('page-change', val)
    },
    // formatContent(html) {
    //   const div = document.createElement('div')
    //   div.innerHTML = html
    //   return div.textContent.substring(0, 100) + '...'
    // }
  }
}
</script>

<style lang="scss" scoped>
$primary-color: #43c2cd;
$date-bg-color: #43c2cd;
$title-color: #333;
$content-color: #666;
$transition-speed: 0.3s;

.affairs-container {
  width: 90%;
  margin: 0 auto;
  padding: 2rem 0;
  box-sizing: border-box;
  
  @media (max-width: 1280px) {
    width: 90%;
  }
  @media (max-width: 768px) {
    width: 94%;
    padding: 1.5rem 0;
  }
  @media (max-width: 480px) {
    width: 100%;
    padding: 1rem 15px;
  }

  .article-grid {
    
    display: grid;
    grid-template-columns: repeat(1, 1fr); 
    gap: 30px;
    
    .article-card {
      
      width: 100%;
      background: #eeeeee;
      border-radius: 8px;
      padding: 24px;
      box-shadow: 0 2px 12px rgba(32, 145, 211, 0.1); 
      transition: transform 0.3s ease;
      display:flex;
       justify-content: space-around;
      &:hover {
        transform: translateY(-3px);
      }

      .article-date {
        display: inline-block;
        background: $date-bg-color;
        color: white;
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 1rem;
        margin-bottom: 15px;
        span{
          display: inline-block;
          width: 100%;
          height: 30px;
          font-size: 1.2vw;
          @media screen and (max-width: 768px) {
            margin-top:2px;
            font-size: 1.2vw;
          }
        }
        span:first-child{
          font-size: 3vw;
          margin-top:30px;
          font-size: 2.8vw;
          @media screen and (max-width: 768px) {
            margin-top:20px;
            font-size: 3.5vh;
          }
        }
      }

      .article-title {
        color: #333;
        font-size: 1.1rem;
        font-weight: 600;
        line-height: 1.5;
        margin-bottom: 12px;
      }

      .article-content {
        color: #666;
        // font-size: 18px;
        font-size: 1rem;
        line-height: 1.8;
      }
    }

   
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
      padding: 0 15px;
      
      .article-card {
        padding: 20px;
        margin: 0 10px; 
      }
    }
  }

  .pagination-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 2rem 0;

  .page-nav {
   
    padding: 10px 24px; 
    min-width: 88px;    
    border: 1px solid #ddd;
    border-radius: 22px; 
    color: #666;
    background: transparent;
    transition: all 0.2s ease;
    height: 44px;     
    line-height: 22px;  
    
    &:hover:not(:disabled) {
      background: #f5f5f5;
      border-color: #ccc;
    }
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .page-number {
    
    width: 44px;
    height: 44px;
    border: 1px solid #ddd;
    border-radius: 50%;
    background: transparent;
    color: #666;
    transition: all 0.2s ease;
    flex-shrink: 0;    

    &.active {
      background: #2091d3;
      border-color: #2091d3;
      color: white;
    }
    
    &:hover:not(.active) {
      background: #f5f5f5;
      border-color: #ccc;
    }
  }

  button {
    cursor: pointer;
    font-size: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    font-family: system-ui, -apple-system; 
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
}

.divAll{
  width: 100%;
  margin: 0 auto;
  min-height: 10vh;
  padding:2rem; 
  background: #ffffff;
  border:1px solid #f3f3f3;
  // box-shadow: 1px 5px #c2e1f3;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* 黑色，30%透明度 */
  margin-bottom: 1rem;
  display: flex;
  div.divL{
    width: 10vw;
    min-width: 80px;
    // height: 10vw;
    // min-height: 80px;
    // margin:3vh;
    // background: rgb(242, 241, 241);
    @media screen and (max-width: 768px) {
      // width: 90px;
      // height: 90px;
    }
    .blockA{
      width:100%;
      height: 100%;
      display: block;
      text-align: center;
      color: #666666;
      span{
        display: inline-block;
        width: 100%;
        height: 30px;
        font-size: 1.5vw;
        @media screen and (max-width: 768px) {
          margin-top:20px;
          font-size: 1rem;
        }
      }
      span:last-child{
        margin-top:10px;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }
      
    }
    
   
  }
  div.divR{
    flex: 1;
    // background: #cbcbcb;
    display:flex;
    flex-direction:column;
    justify-content:center;
    h1{
      font-size: 1.1rem;
      width: 100%;
      margin-bottom: 1vh;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      @media screen and (max-width:768px) {
        font-size: 2.5vh;
        }
    }
    .details {
      width: 100%;
        font-size: 1rem;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        @media screen and (max-width:768px) {
          // font-size: 13px;
        }
      }
      // .details ::v-deep p {
      //   font-size: 2.2vh !important;  /* 覆盖内联样式 */
      //   margin:0 !important;
      //   // margin-top: 0 !important;
      //   font-weight: 100 !important;
      //   color: #666666 !important;
      //   span{
      //     font-size: 2.2vh !important;  /* 覆盖内联样式 */
      //   }
      // }
     
  }
 
}

 .activedivAll{
    background: #f1f8fc !important;
   
    cursor:pointer;
  }
  .activedivAll *{
     color:#015293 !important;
  }
   @media screen and (max-width: 768px) {
    .first-last{
      display: none;
    }
  }
  
  
</style>

